import React from 'react';
import { useState, useContext, useEffect } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import MUIDataTable from "mui-datatables";
import SectorDialogForm from '../../forms/sectorForm';
import loading from '../../../img/seguros_ok_loading.svg';

//styles
import useStyles from './styles'

//Context
import { SectoresContext } from './context';
import { APIContext } from '../../../context';

const SectoresView = () => {

  const classes = useStyles();
  const { editableObject, dialogOpen, handleDialogClose, options, columns, data} = useContext(SectoresContext);
  const [show, setShow ]=  useState(false);
  const { listSectores} = useContext(APIContext);
 
  useEffect(() => {
    //if(data.length > 0){
      setShow(true)
   // }
  }, [data.length]);
  
  useEffect(() => {
    listSectores();
  }, []);

  return (
    <div className={classes.root}>
      <CssBaseline />

      <main className={classes.content}>

        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={0}>
            <Grid item xs={12} md={12} lg={12}>
              <SectorDialogForm dialogOpen={dialogOpen} handleClose={handleDialogClose} array={[editableObject]} edit={true} />
              
              {show ? (
                <MUIDataTable
                  title={"Sectores"}
                  data={data}
                  columns={columns}
                  options={options}

                />
              ) : (
                <div className="loading_container">
                  <img src={loading} className="loading" alt="cargando..." />
                </div>
                
              )}
            </Grid>
          </Grid>
        </Container>
      </main>
    </div>
  );
}

export default SectoresView;